var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "check-shensu" }, [
    _c("div", { staticClass: "shensu-info" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "button-con button-con-right" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("dialogVisible")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-ok",
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.confirmModify },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "head-title-main" }, [
      _c("i", { staticClass: "el-icon-warning danger" }),
      _vm._v("请确认是否同意提成类型的被修改结果"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }